<template>
  <div id="paramc_common">
    <p v-if="isShelf && isShelfType==1">
      <span class="product_manual_margin">商品サイズは固定です。サイズを確認してください。</span><br>
      <span class="product_manual_margin">幅を1mm単位で入力できる商品もございます。</span><br>
    </p>
    <p v-if="isShelf && isShelfType==2">
      <span class="product_manual_margin">高さ、奥行きは固定です。サイズを確認してください。</span><br>
    </p>
    <div id="prodcut_input_area">
      <div id="reference_image">
        <div v-for="(inputRef, index) in targetPlan.inputReferenceList" :key="'inputRefImage-' + index">
          <div class="filler_text" v-if="targetPlan.inputReferenceList.length > 1">{{inputRef.tabName}}</div>
          <img :src="getImage('top/item/input/' + inputRef.img)" width="100%" height="100%">
        </div>
      </div>
      <div class="product_input_size_area">
        <div class="product_input_size">
          <div>
            <!-- <div class="size_title">W</div> -->
            <!-- <div class="size_comb"> -->
            <div>幅（W）</div>
            <div>
              <template v-if="isDisableWidth"><div class="fixed_size">{{paramForm.width}}</div></template>
              <template v-else>
                <input type="text" v-model="paramForm.width" @keypress="validateNumber" @input="paramForm.width=inputRestNumber($event)" @blur="onBlurStorageItemW" @focus="selectedAll">
                <div class="small_text">設定可能値:{{paramForm.minWidth}}mm ～ {{paramForm.maxWidth}}mm</div>
              </template>
            </div>
          </div>
        </div>
        <div class="product_input_size">
          <div>
            <!-- <div class="size_title">H</div> -->
            <!-- <div class="size_comb"> -->
            <div>高さ（H）</div>
            <div>
              <template v-if="isDisable">
                <input type="text" @focus="selectedAll" :disabled="isDisable">
              </template>
              <template v-else-if="isDisableHeight"><div class="fixed_size">{{paramForm.height}}</div></template>
              <template v-else>
                <input type="text" v-model="paramForm.height" @keypress="validateNumber" @input="paramForm.height=inputRestNumber($event)" @blur="onBlurStorageItemH" @focus="selectedAll">
                <div class="small_text">設定可能値:{{paramForm.minHeight}}mm ～ {{paramForm.maxHeight}}mm</div>
              </template>
            </div>
          </div>
        </div>
        <div class="product_input_size">
          <div>
            <!-- <div class="size_title">H</div> -->
            <!-- <div class="size_comb"> -->
            <div>奥行き（D）</div>
            <div>
              <template v-if="isDisableDepth"><div class="fixed_size">{{paramForm.depth}}</div></template>
              <template v-else>
                <input type="text" v-model="paramForm.depth" @keypress="validateNumber" @input="paramForm.depth=inputRestNumber($event)" @blur="onBlurStorageItemD" @focus="selectedAll">
                <div class="small_text">設定可能値:{{paramForm.minDepth}}mm ～ {{paramForm.maxDepth}}mm</div>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="errors_field">
      <div v-if="errors.width" class="error_text middle_text">{{errors.width}}</div>
      <div v-if="errors.height" class="error_tex middle_text">{{errors.height}}</div>
      <div v-if="errors.depth" class="error_text middle_text">{{errors.depth}}</div>
    </div>
    <div class="separate_line"></div>
  </div>
</template>
<script>
import * as Check from '../../../../../utils/Check'
import * as App from '../../../../../utils/App'
import * as FormUtil from '../../../../../utils/FormUtil'

const MIN_BURY_SIZE = 0
const MAX_BURY_SIZE = 300

export default {
  components: {
  },
  props: {
    targetPlan: Object,
    isDisableForm: Boolean,
    isExecOrder: Boolean,
    isShelf: Boolean,
    isShelfType: Number
  },
  data () {
    return {
      paramForm: {
        width: '',
        height: '',
        height2: '',
        depth: '',
        depth2: '',
        minWidth: '',
        maxWidth: '',
        minHeight: '',
        maxHeight: '',
        minDepth: '',
        maxDepth: '',
        fillerSizeLeft: '',
        fillerSizeRight: '',
        fillerSizeCounter: '',
        fillerTypeLeft: 0,
        fillerTypeRight: 0,
        fillerTypeCounter: 0,
        fillerDisableLeft: false,
        fillerDisableRight: false,
        fillerDisableCounter: false
      },
      errors: {},
      warns: {},
      tabType: 2
    }
  },
  watch: {
    targetPlan: function (plan) {
      console.log('param size2 watch')
      this.paramForm.width = plan.dcWidth
      this.paramForm.height = plan.dcHeight
      this.paramForm.height2 = plan.dcHeight2
      this.paramForm.depth = plan.dcDepth
      this.paramForm.depth2 = plan.dcDepth2
      this.paramForm.minWidth = plan.dcMinWidth
      this.paramForm.maxWidth = plan.dcMaxWidth
      this.paramForm.minHeight = plan.dcMinHeight
      this.paramForm.maxHeight = plan.dcMaxHeight
      this.paramForm.minDepth = plan.dcMinDepth
      this.paramForm.maxDepth = plan.dcMaxDepth
      this.paramForm.fillerSizeLeft = undefined
      this.paramForm.fillerSizeRight = undefined
      this.paramForm.fillerSizeCounter = undefined
      this.paramForm.fillerTypeLeft = undefined
      this.paramForm.fillerTypeRight = undefined
      this.paramForm.fillerTypeCounter = undefined
      this.paramForm.fillerDisableLeft = plan.dcBTypeDisableFlg
      this.paramForm.fillerDisableRight = plan.dcCTypeDisableFlg
      this.paramForm.fillerDisableCounter = plan.dcDTypeDisableFlg
    }
    // targetPlan: {
    //   deep: true,
    //   handler (plan) {
    //     console.log(plan)
    //     this.paramForm.width = plan.dcWidth
    //     this.paramForm.height = plan.dcHeight
    //     this.paramForm.height2 = plan.dcHeight2
    //     this.paramForm.depth = plan.dcDepth
    //     this.paramForm.depth2 = plan.dcDepth2
    //     this.paramForm.minWidth = plan.dcMinWidth
    //     this.paramForm.maxWidth = plan.dcMaxWidth
    //     this.paramForm.minHeight = plan.dcMinHeight
    //     this.paramForm.maxHeight = plan.dcMaxHeight
    //     this.paramForm.minDepth = plan.dcMinDepth
    //     this.paramForm.maxDepth = plan.dcMaxDepth
    //     this.paramForm.fillerSizeLeft = undefined
    //     this.paramForm.fillerSizeRight = undefined
    //     this.paramForm.fillerSizeCounter = undefined
    //     this.paramForm.fillerTypeLeft = undefined
    //     this.paramForm.fillerTypeRight = undefined
    //     this.paramForm.fillerTypeCounter = undefined
    //     this.paramForm.fillerDisableLeft = plan.dcBTypeDisableFlg
    //     this.paramForm.fillerDisableRight = plan.dcCTypeDisableFlg
    //     this.paramForm.fillerDisableCounter = plan.dcDTypeDisableFlg
    //   }
    // }
  },
  computed: {
    itemWidth: function () {
      let size = Number(this.paramForm.width)
      // マイナス値にはさせない
      if (size <= 0) {
        size = Number(0)
      }
      return size
    },
    itemHeight: function () {
      let size = Number(this.paramForm.height)
      // マイナス値にはさせない
      if (size <= 0) {
        size = Number(0)
      }
      return size
    },
    itemDepth: function () {
      let size = Number(this.paramForm.depth)
      // マイナス値にはさせない
      if (size <= 0) {
        size = Number(0)
      }
      return size
    },
    isDisableWidth: function () {
      return this.paramForm.minWidth === this.paramForm.maxWidth
    },
    isDisableHeight: function () {
      return this.paramForm.minHeight === this.paramForm.maxHeight
    },
    isDisableDepth: function () {
      return this.paramForm.minDepth === this.paramForm.maxDepth
    },
    isDisable: function () {
      return (this.paramForm.minHeight === this.paramForm.maxHeight) && this.paramForm.height === 0
    },
    minSizeMeasure: function () {
      let minSizeText = '最小商品寸法:'
      if (this.paramForm.minWidth && this.paramForm.minWidth > 0) {
        minSizeText += 'W' + this.paramForm.minWidth
      }
      if (this.paramForm.minHeight && this.paramForm.minHeight > 0) {
        minSizeText += 'H' + this.paramForm.minHeight
      }
      if (this.paramForm.minDepth && this.paramForm.minDepth > 0) {
        minSizeText += 'D' + this.paramForm.minDepth
      }
      return minSizeText
    },
    maxSizeMeasure: function () {
      let maxSizeText = '最大商品寸法:'
      if (this.paramForm.maxWidth && this.paramForm.maxWidth > 0) {
        maxSizeText += 'W' + this.paramForm.maxWidth
      }
      if (this.paramForm.maxHeight && this.paramForm.maxHeight > 0) {
        maxSizeText += 'H' + this.paramForm.maxHeight
      }
      if (this.paramForm.maxDepth && this.paramForm.maxDepth > 0) {
        maxSizeText += 'D' + this.paramForm.maxDepth
      }
      return maxSizeText
    },
    isEnableHeight2: function () {
      if (this.paramForm.minHeight2 === undefined && this.paramForm.maxHeight2 === undefined) return false
      if (this.paramForm.minHeight2 === 0 && this.paramForm.maxHeight2 === 0) return false
      return true
    }
  },
  methods: {
    getParam: function () {
      let param = {
        width: this.paramForm.width,
        height: this.paramForm.height,
        height2: this.isEnableHeight2 ? this.paramForm.height2 : undefined,
        depth: this.paramForm.depth,
        depth2: this.paramForm.depth2,
        minWidth: this.paramForm.minWidth,
        maxWidth: this.paramForm.maxWidth,
        minHeight: this.paramForm.minHeight,
        maxHeight: this.paramForm.maxHeight,
        minDepth: this.paramForm.minDepth,
        maxDepth: this.paramForm.maxDepth,
        fillerSizeLeft: this.paramForm.fillerSizeLeft,
        fillerSizeRight: this.paramForm.fillerSizeRight,
        fillerSizeCounter: this.paramForm.fillerSizeCounter,
        fillerTypeLeft: this.paramForm.fillerTypeLeft,
        fillerTypeRight: this.paramForm.fillerTypeRight,
        fillerTypeCounter: this.paramForm.fillerTypeCounter,
        fillerDisableLeft: this.paramForm.fillerDisableLeft,
        fillerDisableRight: this.paramForm.fillerDisableRight,
        fillerDisableCounter: this.paramForm.fillerDisableCounter
      }
      return param
    },
    validateNumber: function (event) {
      if (!Check.isNumber(event.key)) {
        event.preventDefault()
        return false
      }
      return true
    },
    onBlurStorageItemW: function () {
      if (!this.paramForm.width || this.paramForm.width <= 0) {
        this.paramForm.width = 0
      }
      // 計算後の値をチェックする。
      let ret = this.validateItemW()
      if (!ret) {
        return false
      }
    },
    onBlurStorageItemH: function () {
      if (!this.paramForm.height || this.paramForm.height <= 0) {
        this.paramForm.height = 0
      }
      // 計算前の値をチェックする
      let ret = this.validateItemH()
      if (!ret) {
        return false
      }
    },
    onBlurStorageItemD: function () {
      // 商品サイズ
      if (!this.paramForm.depth || this.paramForm.depth <= 0) {
        this.paramForm.depth = 0
      }
      let ret = this.validateItemD()
      if (!ret) {
        return false
      }
    },
    selectedAll: function (event) {
      event.target.select()
    },
    inputRestNumber: function (event) {
      // テキスト補正
      let str = FormUtil.restHalfNumber(event.target.value)
      str = FormUtil.deleteTopZero(str)
      return str
    },
    checkParam: function () {
      let isCheckW = this.validateItemW()
      let isCheckH = this.validateItemH()
      let isCheckD = this.validateItemD()
      return isCheckW && isCheckH && isCheckD
    },
    validateItemW: function () {
      let ret = true
      // 商品サイズのチェック
      if (this.itemWidth < this.paramForm.minWidth) {
        this.errors['width'] = 'Wの商品サイズは最小商品寸法より大きい値になるようにご入力ください。'
        ret = false
      } else if (this.itemWidth > this.paramForm.maxWidth) {
        this.errors['width'] = 'Wの商品サイズは最大商品寸法より小さい値になるようにご入力ください。'
        ret = false
      }

      if (ret) {
        delete this.errors.width
      }
      this.$forceUpdate()
      return ret
    },
    validateItemH: function () {
      let ret = true
      if (this.itemHeight < this.paramForm.minHeight) {
        this.errors['height'] = 'Hの商品サイズは最小商品寸法より大きい値になるようにご入力ください。'
        ret = false
      } else if (this.itemHeight > this.paramForm.maxHeight) {
        this.errors['height'] = 'Hの商品サイズは最大商品寸法より小さい値になるようにご入力ください。'
        ret = false
      }
      if (ret) {
        delete this.errors.height
      }
      this.$forceUpdate()
      return ret
    },
    validateItemD: function () {
      let ret = true
      if (this.itemDepth < this.paramForm.minDepth) {
        this.errors['depth'] = 'Dの商品サイズは最小商品寸法より大きい値になるようにご入力ください。'
        ret = false
      } else if (this.itemDepth > this.paramForm.maxDepth) {
        this.errors['depth'] = 'Dの商品サイズは最大商品寸法より小さい値になるようにご入力ください。'
        ret = false
      }

      if (ret) {
        delete this.errors.depth
      }
      this.$forceUpdate()
      return ret
    },
    checkFillerLeft: function (size) {
      let retSize = 0
      if (size < MIN_BURY_SIZE) {
        this.warns['fillerLeft'] = '警告：左壁側の埋め込みの最小値は' + MIN_BURY_SIZE + 'mmです。'
        retSize = MIN_BURY_SIZE
      } else if (size > MAX_BURY_SIZE) {
        this.warns['fillerLeft'] = '警告：左壁側の埋め込みの最大値は' + MAX_BURY_SIZE + 'mmです。'
        retSize = MAX_BURY_SIZE
      } else {
        delete this.warns.fillerLeft
        retSize = size
      }
      this.$forceUpdate()
      return retSize
    },
    checkFillerRight: function (size) {
      let retSize = 0
      if (size < MIN_BURY_SIZE) {
        this.warns['fillerRight'] = '警告：右壁側の埋め込みの最小値は' + MIN_BURY_SIZE + 'mmです。'
        retSize = MIN_BURY_SIZE
      } else if (size > MAX_BURY_SIZE) {
        this.warns['fillerRight'] = '警告：右壁側の埋め込みの最大値は' + MAX_BURY_SIZE + 'mmです。'
        retSize = MAX_BURY_SIZE
      } else {
        delete this.warns.fillerRight
        retSize = size
      }
      this.$forceUpdate()
      return retSize
    },
    checkMaxFillerCounter: function (size) {
      let retSize = 15
      if (size < MIN_BURY_SIZE) {
        this.warns['fillerCounter'] = '警告：奥壁側の埋め込みの最小値は' + MIN_BURY_SIZE + 'mmです。'
        retSize = MIN_BURY_SIZE
      } else if (size > MAX_BURY_SIZE) {
        this.warns['fillerCounter'] = '警告：奥壁側の埋め込みの最大値は' + MAX_BURY_SIZE + 'mmです。'
        retSize = MAX_BURY_SIZE
      } else {
        delete this.warns.fillerCounter
        retSize = size
      }
      this.$forceUpdate()
      return retSize
    },
    getImage: function (image) {
      return App.getMmstyleResource(image)
    }
  },
  mounted: function () {
  }
}
</script>
<style src="../../../../css/dc-customize.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/hakotan/components/top/input/paramater/DcParamSize2.vue